import { AreaCursoCertificacao } from 'src/tipos'

export const OPCOES_AREA = [
  {
    id: AreaCursoCertificacao[AreaCursoCertificacao.ProgramasBasicos],
    texto: 'Programas Básicos'
  },
  {
    id: AreaCursoCertificacao[AreaCursoCertificacao.Educacao],
    texto: 'Educação'
  },
  {
    id: AreaCursoCertificacao[AreaCursoCertificacao.ArtesHumanidades],
    texto: 'Artes e Humanidades'
  },
  {
    id:
      AreaCursoCertificacao[
        AreaCursoCertificacao.CienciasSociaisComunicacaoInformacao
      ],
    texto: 'Ciências Sociais, comunicação e informação'
  },
  {
    id:
      AreaCursoCertificacao[AreaCursoCertificacao.NegociosAdministracaoDireito],
    texto: 'Negócios, administração e direito'
  },
  {
    id:
      AreaCursoCertificacao[
        AreaCursoCertificacao.CienciasNaturaisMatematicaEstatistica
      ],
    texto: 'Ciências naturais, matemática e estatística'
  },
  {
    id:
      AreaCursoCertificacao[
        AreaCursoCertificacao.ComputacaoTecnologiasInformacaoComunicacao
      ],
    texto: 'Computação e Tecnologias da Informação e Comunicação (TIC)'
  },
  {
    id:
      AreaCursoCertificacao[AreaCursoCertificacao.EngenhariaProducaoConstrucao],
    texto: 'Engenharia, produção e construção'
  },
  {
    id:
      AreaCursoCertificacao[
        AreaCursoCertificacao.AgriculturaSivilculturaPescaVeterinaria
      ],
    texto: 'Agricultura, silvicultura, pesca e veterinária'
  },
  {
    id: AreaCursoCertificacao[AreaCursoCertificacao.SaudeBemEstar],
    texto: 'Saúde e bem-estar'
  },
  {
    id: AreaCursoCertificacao[AreaCursoCertificacao.Servicos],
    texto: 'Serviços'
  }
]
